<template>
  <div class="header_box" v-if="isWX">
    <img
      class="logo"
      src="http://cdn.yxvzb.com/newWechat/image/logo98.png"
      alt=""
      @click="jump"
    />
    <div class="search_box cl" v-if="title == '医学V视界'">
      <span class="icon iconfont icon-search"></span>
      <input type="text" placeholder="请输入关键词" @focus="focus" />
    </div>
    <div class="title" v-else>
      {{ title }}
    </div>
    <div v-if="title != '个人中心'">
      <img
        v-if="wxUserInfo && wxUserInfo.phone"
        @click="toPersonal"
        class="photo"
        :src="wxUserInfo.headPhoto"
        alt=""
      />
      <span class="login" v-else-if="title != '头条详情'" @click="login">
        登录
      </span>
    </div>
    <div v-else style=" width: .6933rem;height: .6933rem;"></div>
  </div>
  <!--APP中打开-->
  <div class="header_box app_header" v-else>
    <div v-show="title == '医学V视界'" style="padding: .2rem;width: 90%;">
      <div class="search_box cl app_search_box" style="width: 100%;">
        <span class="icon iconfont icon-search"></span>
        <input
          type="text"
          placeholder="请输入关键词"
          style="width: 32%;"
          @focus="focus"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
  name: '',
  props: {
    title: {
      //title   == 医学V视界 则为所搜
      type: String,
      default: ''
    },
    wxUserInfo: {
      default: function() {
        return {};
      }
    }
  },
  data() {
    return {
      isLogin: false,
      isWX: true
    };
  },
  methods: {
    focus() {
      this.$router.push({ name: 'search' });
    },
    jump() {
      this.$router.push({ name: 'home' });
      //        location.href = '/'
    },
    login() {
      this.$router.push({ name: 'register' });
    },
    toPersonal() {
      this.$router.push({ name: 'personal' });
    }
  },
  computed: {
    ...mapState({
      headerName: state => state.headerName
    })
  },
  watch: {
    //不能监听到？？？
    //      wxUserInfo(n,o){
    //        console.log(o)
    //        console.log(n)
    //        if (n && n.phone) {
    //          this.isLogin = true
    //        } else {
    //          this.isLogin = false
    //        }
    //      }
  },
  components: {},
  created() {
    if (this.$api.isKln()) {
      this.isWX = false;
    }
  }
};
</script>
<style lang="less" scoped>
.header_box {
  padding: 0.1866rem 0.4rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 1.0933rem;
  border-bottom: 1px solid #ebebeb;
  .logo {
    width: 0.72rem;
    height: 0.6133rem;
  }
  .search_box {
    padding: 0.106rem 0.266rem;
    width: 6.72rem;
    position: relative;
    background: #f3f3f3;
    border-radius: 0.1rem;
    display: flex;
    align-items: center;
    span {
      float: left;
    }
    input {
      background: #f3f3f3;
      border: none;
      margin-left: 0.2rem;
      font-size: 0.3733rem;
      width: 80%;
      height: 0.6rem;
      float: left;
      height: 0.6rem;
    }
  }
  .title {
    width: 7.5rem;
    font-size: 0.4266rem;
    border-left: 0.0533rem solid #5cb2ff;
    color: #000;
    /*border-radius: .08rem;*/
    margin-left: 0.2133rem;
    padding-left: 0.2133rem;

    line-height: 0.533rem;
    height: 0.533rem;
    /*margin-top: .2rem;*/
  }
  .photo {
    width: 0.6933rem;
    border-radius: 50%;
    height: 0.6933rem;
  }
  .login {
    width: 0.8rem;
    height: 0.6933rem;
    text-align: center;
    line-height: 0.6933rem;
    font-size: 0.3rem;
  }
}
.app_header {
  justify-content: center;
  height: auto;
  padding: 0;
}
.app_search_box {
  display: flex;
  justify-content: center;
}
</style>
